/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { Divider, IconButton, List, Text } from 'react-native-paper';
import { useSelector } from 'react-redux';
import { FlatList, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Modal from 'react-native-modal';
import { modalConatiner, modalHeader, theme } from '../../theme/theme';

const CategoriesModal = ({ visible, onCategoryModalClose, onCategorySelect }) => {
    const categories = useSelector(state => state.canteen.categories);
    const [isModalVisisble, setModalVisible] = useState(visible);

    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    const closeMenuItemModal = () => {
        setModalVisible(false);
        if (onCategoryModalClose) {
            onCategoryModalClose(false);
        }
    };

    const onCategoryClick = ({ item, index }) => {
        if (onCategorySelect) {
            onCategorySelect(index);
        }
    };

    const renderItem = ({ item, index }) => <List.Item onPress={() => onCategoryClick({ item, index })} title={item?.category_name} titleStyle={{ fontSize: 14 }} />;

    return (
        <Modal
            animationOutTiming={300}
            coverScreen={true}
            backdropTransitionOutTiming={300}
            hideModalContentWhileAnimating={true}
            isVisible={isModalVisisble}
            onBackButtonPress={closeMenuItemModal}
            onBackdropPress={closeMenuItemModal}
            style={modalConatiner}>
            <SafeAreaView style={styles.modalView}>
                <View style={[modalHeader, { backgroundColor: theme.colors.primary }]}>
                    <Text variant="titleMedium" style={{ color: theme.colors.onPrimary }}>Categories</Text>
                    <IconButton icon="close"
                        onPress={closeMenuItemModal}
                        iconColor={theme.colors.onPrimary}
                        size={20} />
                </View>
                <Divider />
                <FlatList
                    data={categories}
                    renderItem={renderItem}
                    keyExtractor={(item, index) => (item?.category_id).toString()}
                // ListFooterComponent={<Divider />}
                />
            </SafeAreaView>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalView: {
        // flexGrow: 1,
        maxHeight: '75%',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        margin: 6,
    },
});

export default CategoriesModal;

